export default [
    'Asset Management',
    'Banking',
    'Commercial Services',
    'Consumer Products',
    'Consumer Services',
    'Hardware',
    'Hydrocarbons',
    'Insurance',
    'Machinery',
    'Materials & Chemicals',
    'Media',
    'Pharma & Healthcare',
    'Real Estate',
    'Retail',
    'Software',
    'Technology Services',
    'Transportation & Logistics',
    'Utilities',
];

const newIndustries = [
    'Banking & Finance',
    'Commercial Services',
    'Consumer Products',
    'Technology Services',
    'Hardware',
    'Insurance',
    'Machinery & Automotive',
    'Materials & Chemicals',
    'Media & Entertainment',
    'Healthcare & Pharma',
    'Real Estate & Construction',
    'Software',
    'Energy & Utilities',
    'Transport & Logistics',
    'Food & Hospitality',
    'Online Services',
    'Professional Services',
    'Consumer Services',
];

const icons = {
    'Asset Management': 'fa-file-invoice-dollar',
    Banking: 'fa-university',
    'Commercial Services': 'fa-business-time',
    'Consumer Products': 'fa-shopping-bag',
    'Consumer Services': 'fa-hotel',
    Hardware: 'fa-microchip',
    Hydrocarbons: 'fa-gas-pump',
    Insurance: 'fa-hands',
    Machinery: 'fa-cogs',
    'Materials & Chemicals': 'fa-pallet',
    Media: 'fa-tv',
    'Pharma & Healthcare': 'fa-pills',
    'Real Estate': 'fa-building',
    Retail: 'fa-shopping-cart',
    Software: 'fa-laptop-code',
    'Technology Services': 'fa-server',
    'Transportation & Logistics': 'fa-road',
    Utilities: 'fa-plug',
};
const newIcons = {
    'Banking & Finance': 'Banking-Finance',
    'Commercial Services': 'Commercial-Services',
    'Consumer Products': 'Consumer-Products',
    'Technology Services': 'Technology-Services',
    Hardware: 'Hardware',
    Insurance: 'Insurance',
    'Machinery & Automotive': 'Machinery-&-Automotive',
    'Materials & Chemicals': 'Materials-&-Chemicals',
    'Media & Entertainment': 'Media-&-Entertainment',
    'Healthcare & Pharma': 'Healthcare-&-Pharma',
    'Real Estate & Construction': 'Real-Estate-&-Construction',
    Software: 'fa-laptop-code',
    'Energy & Utilities': 'Energy-&-Utilities',
    'Transport & Logistics': 'Transportation-&-Logistics',
    'Food & Hospitality': 'Food-&-Hospitality',
    'Online Services': 'Online-Services',
    'Professional Services': 'Professional-Services',
    'Consumer Services': 'Consumer-Services',
};

export { icons, newIcons, newIndustries };
